/**
 * 生成随机数
 * @param {number} digit 位数
 * */
export const createrRandom = (digit = 6) => {
  let num = '';
  for (var i = 0; i < digit; i++) {
    num += Math.floor(Math.random() * 10);
  }
  return num;
}

export const creatUdid = () => {
  if(localStorage.getItem('udid')) {
    return
  }
  let udid=new Date().getTime() + createrRandom()
  localStorage.setItem('udid',udid)
}
